import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class UpcomingEventsUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult() {
        return await this.repo.getUpcomingEvents();
    }
}
export default UpcomingEventsUseCase;
